import { ThreeDotMenuItem } from "components/ThreeDotMenu";

export const menuItems = (
  published: boolean,
  deleteArticle: () => void,
  onPublishUnpublishClicked: () => void
): ThreeDotMenuItem[] => [
  {
    label: published ? "Unpublish" : "Publish",
    onClick: onPublishUnpublishClicked,
  },
  {
    label: "Delete",
    onClick: deleteArticle,
    className: "text-red-500",
  },
];
